import { FC, useEffect, useState } from "react";
import ConferenceMap from "./ConferenceMap";
import { useQuery } from "@tanstack/react-query";
import { nodeServer } from "../constants";
import { ConferenceAttendee, IConference, IConferenceAttendee } from "./conferenceTypes";
import { Card, CardFooter, CardHeader, Image, Input, Label, Text } from "@fluentui/react-components";
import LinkRouter from "../LinkRouter";
import { accessTokenInfo$ } from "../oauth/oauth";
import { useObservable } from "../utility/useObservable";
import { memberObservable } from "../store/userStore";
import "./Conference.css";
import { parseLocalDate } from "../utility/DateParse";
import { ISponsorshipInfo, SponsorshipTier } from "../../shared/conferenceModels";
import { useGeneralStyles } from "../styles";

interface IConferenceProps {}

const Conference: FC<IConferenceProps> = () => {
    const userState = useObservable(memberObservable);

    const [confirmationCode, setConfirmationCode] = useState<string>("");

    const { data: conference } = useQuery({
        queryKey: ["conferenceConference"],
        refetchOnWindowFocus: false,
        enabled: true,
        queryFn: async (signal) => {
            const url = nodeServer + `conference/latest`;
            const res = await fetch(url, { signal: signal.signal });
            if (!res.ok) {
                throw new Error("Network response was not ok");
            }
            const conference: IConference = await res.json();
            //const conference = conferenceData;
            if (conference.data.conferenceDetails?.registrationFeeSchedule) {
                for (const item of conference.data.conferenceDetails?.registrationFeeSchedule) {
                    console.log(`deadline: ${item.deadline}`);
                    const deadline = parseLocalDate(item.deadline as unknown as string);
                    if (deadline) {
                        item.deadline = deadline;
                    }
                    item.deadline = new Date(item.deadline as unknown as string);
                    console.log(`deadline: ${item.deadline}`);
                }
            }

            // conference.data.conferenceDetails!.registrationDeadline = new Date(conference.data.conferenceDetails!.registrationDeadline as unknown as string);
            // conference.data.conferenceDetails!.lateRegistrationDeadline = new Date(conference.data.conferenceDetails!.lateRegistrationDeadline as unknown as string);
            // conference.data.conferenceDetails!.abstractSubmissionDeadline = new Date(conference.data.conferenceDetails!.abstractSubmissionDeadline as unknown as string);
            console.log(`start date: ${conference.data.conferenceDetails!.startDate}`);
            conference.data.conferenceDetails!.startDate = new Date(conference.data.conferenceDetails!.startDate as unknown as string);
            const startDate = parseLocalDate(conference.data.conferenceDetails!.startDate as unknown as string);

            console.log(`start date: ${startDate}`);
            console.log(`start date: ${conference.data.conferenceDetails!.startDate}`);
            if (startDate) {
                conference.data.conferenceDetails!.startDate = startDate;
            }

            conference.data.conferenceDetails!.endDate = new Date(conference.data.conferenceDetails!.endDate as unknown as string);
            const endDate = parseLocalDate(conference.data.conferenceDetails!.endDate as unknown as string);
            if (endDate) {
                conference.data.conferenceDetails!.endDate = endDate;
            }
            console.log(conference);
            return conference;
        },
    });

    const { data: conferenceSponsors } = useQuery({
        queryKey: ["conferenceSponsors"],
        refetchOnWindowFocus: false,
        enabled: true,
        queryFn: async (signal) => {
            const url = nodeServer + `conference/sponsor/latest`;
            const res = await fetch(url, { signal: signal.signal });
            if (!res.ok) {
                throw new Error("Network response was not ok");
            }
            const sponsors: Partial<ISponsorshipInfo>[] = await res.json();
            console.log(sponsors);
            return sponsors;
        },
    });

    const { data: conferenceAttendee, refetch } = useQuery({
        queryKey: ["conferenceAttendeeConference"],
        refetchOnWindowFocus: false,
        enabled: !!conference,
        queryFn: async (signal) => {
            if (accessTokenInfo$.value != null && accessTokenInfo$.value.accessToken != null) {
                const headers = new Headers();
                headers.append("Authorization", "Bearer " + accessTokenInfo$.value.accessToken);

                // if (userState !== null) {
                const url = nodeServer + `conference/status`;
                const res = await fetch(url, { headers: headers, method: "get", signal: signal.signal });
                if (!res.ok) {
                    throw new Error("Network response was not ok");
                }
                const json = await res.json();
                if (json.error) {
                    console.log(json.error);
                }
                if (json.user !== null) {
                    return json.user as IConferenceAttendee;
                } else {
                    let attendee: IConferenceAttendee = new ConferenceAttendee();
                    if (userState) {
                        attendee = ConferenceAttendee.fromIMemberInfo(userState);
                    }
                    ConferenceAttendee.setupDetails(attendee, conference!.data);
                    return attendee;
                }
            } else {
                let attendee: IConferenceAttendee = new ConferenceAttendee();
                if (userState) {
                    attendee = ConferenceAttendee.fromIMemberInfo(userState);
                }
                ConferenceAttendee.setupDetails(attendee, conference!.data);
                return attendee;
            }
            //}
        },
    });

    const getSizeForTier = (tier: number) => {
        switch (tier) {
            case 0:
                return 100;
            case 1:
                return 200;
            case 2:
                return 300;
            default:
                return 100;
        }
    };

    useEffect(() => {
        console.log("refetch");
        refetch();
        //queryClient.refetchQueries({queryKey: ["conferenceAttendee"]});
    }, [userState]);

    const generalStyles = useGeneralStyles();

    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                <Text size={800} as="h2">
                    2YC3's {conference?.number} Conference
                </Text>
                <Text size={600}>{conference?.name}</Text>
                Date:
                <Text size={500} style={{ marginLeft: 10 }}>
                    {conference?.data.conferenceDetails?.startDate?.toDateString()} - {conference?.data.conferenceDetails?.endDate?.toDateString()}
                </Text>
                Location:
                <Text style={{ marginLeft: 10 }} size={500}>
                    {conference?.data.conferenceDetails?.location}
                </Text>
                <Text style={{ marginLeft: 10 }} size={400}>
                    7600 Takoma Avenue, Takoma Park, MD 20912
                </Text>
                <br />
                {conferenceSponsors && conferenceSponsors.length > 0 && (
                    <>
                        <Text className={generalStyles.cardTitle}>Sponsored by:</Text>
                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center", justifyContent: "start", gap: 10, marginBottom: 20 }}>
                            {conferenceSponsors
                                .sort((a, b) => (+a.tier! < +b.tier! ? 1 : -1))
                                .map((sponsor, index) => (
                                    <Card appearance="filled" key={index} style={{}}>
                                        <div key={index} style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative" }}>
                                            {sponsor.imageUrl && (
                                                <a href={sponsor.linkUrl} target="_blank" rel="noopener noreferrer">
                                                    <Image
                                                        src={sponsor.imageUrl}
                                                        alt={`${sponsor.title} logo`}
                                                        width={getSizeForTier(+sponsor.tier!)}
                                                        height={getSizeForTier(+sponsor.tier!)}
                                                        style={{ maxWidth: getSizeForTier(+sponsor.tier!), maxHeight: getSizeForTier(+sponsor.tier!), objectFit: "contain" }}
                                                    />
                                                </a>
                                            )}
                                            <Text className={sponsor.tier === SponsorshipTier.Bronze ? generalStyles.caption2 : generalStyles.body2} style={{ position: "absolute", bottom: 0, width: getSizeForTier(+sponsor.tier!), textAlign: "center", background: "rgba(255,255, 255, 0.5)", marginBottom: sponsor.tier === SponsorshipTier.Bronze ? -10 : "auto"}}>
                                                {sponsor.title}
                                            </Text>
                                        </div>
                                    </Card>
                                ))}
                        </div>
                    </>
                )}
                <Card appearance="outline" size="small" style={{ width: "max-content" }}>
                    <CardHeader header={"Table of Contents"} />
                    <ol style={{ margin: 0 }}>
                        <li key={-2}>
                            <a href={`#Registration`}>Registration</a>
                        </li>
                        <li key={-1}>
                            <a href={`#Sponsor`}>Sponsor Opportunities</a>
                        </li>
                        {conference?.data.pageCards?.map((card, index) => (
                            <li key={index}>
                                <a href={`#${card.title.replaceAll(" ", "-").replaceAll("$", "")}`}>{card.title}</a>
                            </li>
                        ))}
                        <li key={-3}>
                            <a href={`#Map`}>Map</a>
                        </li>
                    </ol>
                </Card>
                {conferenceAttendee?.conferenceId === conference?.id ? (
                    <Card style={{ marginTop: 10 }} id="Registration">
                        <CardHeader header={<Text size={500}>Registration</Text>} />
                        You are currently registered for this conference! We look forward to seeing you there.
                        <CardFooter>
                            <LinkRouter as="ButtonLink" href="/conference/register">
                                Make changes to your registration.
                            </LinkRouter>
                        </CardFooter>
                    </Card>
                ) : (
                    <Card style={{ marginTop: 10 }} id="Registration">
                        <CardHeader header={<Text size={500}>Registration</Text>} />
                        <Text>
                            We'd love to have you join us. Registration fees are listed in the table below. <br />
                            Please note that members of 2YC3 receive a discount on registration fees. If you are a member, please <b>log in</b> to receive the discount. <br /> You may opt to become a member before registering to receive the discount, too!
                        </Text>
                        <div style={{ minWidth: 320 }}>
                            <table style={{ borderCollapse: "collapse", border: "1px solid" }}>
                                <tbody>
                                    <tr>
                                        <th>Status</th>
                                        <th>Deadline</th>
                                        <th>Fee</th>
                                    </tr>
                                    {conference?.data.conferenceDetails?.registrationFeeSchedule?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.status}</td>
                                            <td>{item.deadline.toDateString()}</td>
                                            <td>${item.fee}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        Use the button below to register!
                        <CardFooter>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <LinkRouter appearance="primary" as="ButtonLink" href="/conference/register">
                                    Register
                                </LinkRouter>
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "end" }}>
                                    <div>
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <Label>Already registered?</Label>
                                            <Input value={confirmationCode} onChange={(_, d) => setConfirmationCode(d.value)} placeholder="confirmation code..." />
                                        </div>
                                    </div>
                                    <LinkRouter as="ButtonLink" href={`/conference/confirmation?confirmationCode=${confirmationCode}`}>
                                        Use Confirmation Code
                                    </LinkRouter>
                                </div>
                            </div>
                        </CardFooter>
                    </Card>
                )}
                <Card style={{ marginTop: 10 }} id="Sponsor">
                    <CardHeader header={<Text size={500}>Sponsor Opportunities</Text>} />
                    <Text>Sponsors are welcome and appreciated! If you are interested in sponsoring the conference, please click on the "Info and Registration" button below to learn about sponsorship levels and benefits, and to register as a sponsor.</Text>
                    <CardFooter>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                            <LinkRouter appearance="primary" as="ButtonLink" href="/conference/sponsor/register">
                                Sponsor Info and Registration
                            </LinkRouter>
                        </div>
                    </CardFooter>
                </Card>
                {conference?.data.pageCards?.map((card, index) => (
                    <Card key={index} style={{ marginTop: 5 }} id={card.title.replaceAll(" ", "-").replaceAll("$", "")}>
                        <CardHeader style={{ marginBottom: 0 }} header={<Text size={500}>{card.title}</Text>} />
                        <div dangerouslySetInnerHTML={{ __html: card.content }} />
                        <CardFooter key={index}>
                            {card.actions?.map((action, index) => (
                                <LinkRouter key={index} appearance={action.primary ? "primary" : "secondary"} as="ButtonLink" href={action.link}>
                                    {action.title}
                                </LinkRouter>
                            ))}
                        </CardFooter>
                    </Card>
                ))}
                <Card style={{ marginTop: 5 }} id="Map">
                    <CardHeader header={<Text size={500}>Map</Text>} />
                    <div style={{ margin: 0 }}>
                        <Text>
                            All conference activities will take place in the <b>Catherine and Isiah Leggett Math and Science Building (LB)</b>, 7615 Fenton Street Takoma Park, MD 20912. The closest Metro station to the campus is Takoma (Red Line), ~0.7 mile from the LB building.
                        </Text>
                        <br /> <br />
                        <ConferenceMap />
                    </div>
                </Card>
                {/* <Card style={{ marginTop: 10 }}>
                    <CardHeader header={<h2>Abstract Submission</h2>} />
                    <div>
                        Abstracts are due by <b>{conference?.data.conferenceDetails?.abstractSubmissionDeadline?.toLocaleDateString()}</b>. Please, submit your abstracts using the button below.
                    </div>
                    <CardFooter>
                        <LinkRouter appearance="primary" as="ButtonLink" href="https://docs.google.com/forms/d/e/1FAIpQLSeduHkWv_z-7zfze68fXCPT_HJ_EIKe-dTX_9m7d6-px6CFPQ/viewform">
                            Submit Abstract
                        </LinkRouter>
                    </CardFooter>
                </Card> */}
                {/* <Card style={{ marginTop: 10 }}>
                    <CardHeader header={<h2>Transportation</h2>} />
                    <div>
                        We recommend having access to a vehicle for transportation around the Kansas City area. While it is possible to stay at a hotel within walking distance from the college and some restaurants, public transportation from MCI (Kansas City International Airport) to JCCC (about 35
                        miles) is not available. Renting a car or relying on ride-share apps or a taxi will be the only options available to get from the airport to the hotels. Parking is always free on our campus.
                    </div>
                </Card> */}
                {/* <Card style={{ marginTop: 10 }}>
                    <CardHeader header={<h2>Lodging</h2>} />
                    There are many options in the area. The following have agreements with JCCC:
                    <Text size={400}>Hotel within walking distance:</Text>
                    <ul>
                        <li>
                            <b>MainStay Suites Kansas City Overland Park</b>
                            <br />
                            11001 Oakmont St. Overland Park KS 66210
                            <br />
                            Phone <a href="tel:(913)-469-5557">(913)-469-5557</a>
                        </li>
                    </ul>
                    <Text size={400}>Other Nearby Hotels:</Text>
                    <ul>
                        <li>
                            <b>DoubleTree by Hilton Kansas City- Overland Park</b>
                            <br />
                            10100 College Blvd, Overland Park KS 66210
                            <br />
                            Phone <a href="tel:(913)-451-6100">(913)-451-6100</a>
                        </li>
                        <li>
                            <b>Drury Inn &amp; Suites Kansas City Overland Park</b>
                            <br />
                            10963 Metcalf Ave, Overland Park 66210
                            <br />
                            Phone <a href="tel:(913)-345-1500">(913)-345-1500</a>
                        </li>
                        <li>
                            <b>Embassy Suites by Hilton Kansas City Overland Park</b>
                            <br />
                            10601 Metcalf Ave at I-435, Overland Park, KS 66212
                            <br />
                            Phone <a href="tel:(913)-649-7060">(913)-649-7060</a>
                        </li>
                    </ul>
                </Card> */}
                {/* <Card style={{ marginTop: 10 }}>
                    <CardHeader header={<h2>Contact &amp; Further Info</h2>} />
                    <div>
                        For further information or questions, please contact:
                        <br />
                        <b>Melanie Harvey, Membership & College Sponsors Chair</b>
                        <br />
                        <a href="mailto:harvey@2yc3.org">harvey@2yc3.org</a>
                    </div>
                    <p>As schedules are finalized, we will post the conference program here. We look forward to seeing you at the conference!</p>
                    <p>See the map below to find the OCB building where the conference will be held. (Circled in red.)</p>
                </Card> */}
            </div>
        </div>
    );
};

export default Conference;
